<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="dsprofile_block">
      <div class="body_inner">
        <h2 class="tilte-info">
          {{ $t("pages.landing.heading") }}
        </h2>
        <div class="profileinfo-block">
          <div class="flex items-center justify-center imgbox">
            <img src="../assets/images/profile-img.png" alt="Profile img" />
          </div>
          <h4>{{ $t("pages.landing.greeting") }}</h4>
          <p>{{ $t("pages.landing.description") }}</p>
        </div>

        <div class="form-group">
          <label class="block label-text">
            {{ $t("pages.landing.input.label") }}
          </label>
          <div class="flex items-center input-group ds-cunstome-picker">
            <span
              class="input-group-addon flex items-center justify-center h-full"
            >
              <img src="./../assets/images/calender.png" alt="Profile img" />
            </span>
            <datepicker
              v-model="date"
              input-class="search-card__datepicker-input pkss-text secondary placeholder-gray-500 form-control card__datepicker "
              :placeholder="$t('pages.landing.input.placeholder')"
              :language="lang"
              :pick-time="true"
              :format="'dd.MM.yyyy'"
              :highlighted="highlighted"
              :disabled-dates="{ to: yesterday }"
              @input="changedDate"
              @selected="selectedDate"
            />
          </div>
        </div>

        <div class="form-group">
          <button
            :class="{ 'disabled:opacity-50': date === null }"
            class="
              flex
              items-center
              justify-center
              btn_apply
              rounded-lg
              w-full
              text-white
              btn_action
              w-full
            "
            :disabled="date === null"
            @click="submitDate()"
          >
            {{ $t("pages.common.buttons.continue") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { de, pl, en } from "vuejs-datepicker/dist/locale";

export default {
  name: "Greeting",
  components: { Datepicker },
  data() {
    return {
      date: null,
      token: " ",
      highlighted: {
        dates: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
        includeDisabled: true,
      },
    };
  },
  computed: {
    lang() {
      if (this.$i18n.locale === "de") {
        return de;
      } else if (this.$i18n.locale === "pl") {
        return pl;
      }

      return en;
    },
    yesterday() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday;
    },
  },
  beforeMount() {
    this.token = this.$route.query["token"];
    this.checkInvitation(this.$route.query["token"]);
  },
  methods: {
    changedDate() {
      this.$store.commit(
        "mission/SET_ANONYMIZED_AVAILABILITY_DATE",
        this.date.toISOString().slice(0, 10)
      );
      this.$emit("date", this.date.toISOString().slice(0, 10));
    },

    selectedDate(date) {
      try {
        const today = new Date().toISOString().slice(0, 10);
        if (date.toISOString().slice(0, 10) < today) {
          this.error = this.$t("component.searchCard.beforeError");
          this.$emit("input", false);
        } else {
          this.error = "";
          this.$emit("input", true);
        }
      } catch {
        this.$emit("input", true);
      }
    },
    // prettier-ignore
    async checkInvitation(token){
      this.$http.get('/invite-user', {
        params:{
          invitation: token
        }
      }).then( (res)=>{
        if(!res.data[0]['pflegekraft_id']){
          this.$router.push('/search');
        }
      });
    },
    // prettier-ignore
    submitDate() {
      this.$http.get('/confirm-invite', {
        params:{
          date: this.date,
          invitation: this.token
        }
      }).then( (res)=>{
        localStorage.setItem('access_token', res.data);
        this.$router.push('/search');
      });
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
  border-color: #c6c6d1;
  border-radius: 4px;
  padding: 0;
  height: 46px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-width: 1px;
}

.input-group .input-group-addon {
  height: 100%;
  padding: 6px 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 12%;
  margin-right: 1%;
}

.input-group .text-control {
  width: 87%;
  height: 100%;
  font-size: 14px;
}

.dsprofile_block {
  display: block;
}

.dsprofile_block .tilte-info {
  color: #333333;
  font-weight: 800;
  margin: 0 0 13px;
  font-size: 18px;
}

.dsprofile_block .profileinfo-block {
  width: 100%;
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
  margin: 10px 0 20px;
  padding: 12px 0 12px 55px;
  position: relative;
}

.dsprofile_block .profileinfo-block .imgbox {
  background: #e7f3f0;
  padding: 1px;
  width: 42px;
  height: 42px;
  border-radius: 100%;
  position: absolute;
  left: 0;
  top: 12px;
}

.dsprofile_block .profileinfo-block .imgbox img {
  width: 100%;
  height: 100%;
}

.dsprofile_block .profileinfo-block h4 {
  font-size: 17px;
  font-weight: 700;
  color: #333333;
  margin: 0 0 3px;
}

.dsprofile_block .profileinfo-block p {
  color: #676666;
  font-weight: 400;
  font-size: 13px;
}

.dsprofile_block .form-group {
  display: block;
  margin: 0 0 15px;
}

.dsprofile_block .form-group .label-text {
  font-size: 14px;
  color: #676666;
  margin: 0 0 10px;
}

/* --------------------- Date Picker css --------------*/
/* --------------------- Date Picker css --------------*/

.ds-cunstome-picker {
  position: relative;
}

.ds-cunstome-picker .input-group-addon {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px !important;
}

.ds-cunstome-picker .vdp-datepicker {
  width: 100%;
  height: 100%;
  align-items: center;
  vertical-align: middle;
}

.ds-cunstome-picker .vdp-datepicker * {
  height: 100%;
}

.ds-cunstome-picker .vdp-datepicker .form-control {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
}

.ds-cunstome-picker .form-control {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
}

.card__datepicker {
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
  height: 45px;
  background: transparent !important;
}

.search-card__datepicker-input {
  font-weight: bold;
  color: #676666;
  width: 100%;
  padding-left: 35px;
  border: 0 !important;
  border-radius: 5px;
  outline: none !important;
  box-shadow: none !important;
  height: 45px;
  background: transparent !important;
}
/*--------------------- Date Picker css --------------*/
</style>
